<template>
  <div class="builderDetails">
    <div v-if="form.LoadingSkeleton" class="detailsList">
      <div class="listTumb" v-for="i in 6" :key="i">
        <div class="thumbHeader">
          <div class="headerContent">
            <div class="contentPic">
              <Skeletor
                style="
                  width: 42px;
                  height: 42px;
                  border-radius: 50%;
                  background: rgb(163, 219, 213);
                "
              />
            </div>
            <div class="contentTitle">
              <div class="userTitle">
                <Skeletor
                  style="
                    width: 112px;
                    height: 22px;
                    border-radius: 9999px;
                    background: rgb(163, 219, 213);
                  "
                />
              </div>
              <div class="userRole">
                <Skeletor
                  style="
                    width: 72px;
                    height: 12px;
                    border-radius: 9999px;
                    background: rgb(163, 219, 213);
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="thumbMain">
          <div class="mainPic">
            <Skeletor
              style="width: 100%; height: 100%; background: rgb(163, 219, 213)"
            />
          </div>
          <div class="mainOptions">
            <div class="optionsList">
              <div v-for="i in 3" :key="i" class="listThumb">
                <Skeletor
                  style="
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    background: rgb(163, 219, 213);
                  "
                />
              </div>
            </div>
            <div class="optionsList">
              <div class="listThumb">
                <Skeletor
                  style="
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    background: rgb(163, 219, 213);
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="thumbFooter">
          <div class="footerTitle">
            <Skeletor
              style="
                width: 60%;
                height: 28px;
                border-radius: 9999px;
                background: rgb(163, 219, 213);
                margin-bottom: 12px;
              "
            />
          </div>
          <div class="footerContent">
            <Skeletor
              v-for="i in 8"
              :key="i"
              style="
                width: 100%;
                height: 16px;
                border-radius: 9999px;
                background: rgb(163, 219, 213);
                margin-bottom: 4px;
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!form.LoadingSkeleton" class="detailsList">
      <div
        class="listTumb"
        v-for="(v, i) in completeInfos?.posts?.list"
        :key="i"
        :id="v.id"
      >
        <div class="thumbHeader">
          <div @click="showProfileHandler" class="headerContent">
            <div class="contentPic">
              <img :src="completeInfos?.avatar" alt="" />
            </div>
            <div class="contentTitle">
              <div class="userTitle">{{ completeInfos?.nickname }}</div>
              <div class="userRole">{{ completeInfos?.role_fn }}</div>
            </div>
          </div>
          <div class="headerOptions">
            <div
              class="userFollowBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != completeInfos?.uid) &&
                completeInfos?.is_follow == 1
              "
              @click="follow(completeInfos?.uid)"
            >
              دنبال کردن
            </div>
            <div
              class="userUnFollowBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != completeInfos?.uid) &&
                completeInfos?.is_follow == 2
              "
              @click="follow(completeInfos?.uid)"
            >
              لغو دنبال کردن
            </div>
            <div
              class="userEditBtn"
              v-if="
                $store.state.auth.loggedIn &&
                $store.state.auth.uid == completeInfos?.uid
              "
              @click="editPostHandler(v.id)"
            >
              <i class="fas fa-edit"></i>
            </div>
            <div
              class="userDelBtn"
              v-if="
                $store.state.auth.loggedIn &&
                $store.state.auth.uid == completeInfos?.uid
              "
              @click="del_post(v.id)"
            >
              <i class="fas fa-trash"></i>
            </div>
          </div>
        </div>
        <div class="thumbMain">
          <div class="mainPic">
            <!-- <img :src="v?.avatar" /> -->
            <Swiper
              :slides-per-view="1"
              :space-between="16"
              :modules="module"
              :pagination="{
                dynamicBullets: true,
              }"
            >
              <SwiperSlide> <img :src="v?.avatar" alt="" /> </SwiperSlide>
              <SwiperSlide v-for="(p, j) in v.photo_galleries_mobile" :key="j">
                <img :src="p.url" alt="" />
              </SwiperSlide>
              <SwiperSlide v-show="v.lat && v.lng">
                <div :id="`map-${v.id}`" class="map"></div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div class="mainOptions">
            <div class="optionsList">
              <div class="listThumb">
                <div
                  class="thumbIcon"
                  @click="save_like(v, i)"
                  :class="{ liked: v.is_like == 2 }"
                >
                  <svg
                    v-if="v.is_like == 1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                    />
                  </svg>
                  <svg
                    v-if="v.is_like == 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                    />
                  </svg>
                </div>
                <div class="thumbNum">{{ v.likes || "0" }}</div>
              </div>
              <div @click="OpenMessage(i)" class="listThumb">
                <div class="thumbIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                    />
                  </svg>
                </div>
                <div class="thumbNum">{{ v.comments_count || "0" }}</div>
              </div>
              <div @click="shareContent(v.conetent)" class="listThumb">
                <div class="thumbIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- <div class="optionsList">
              <div @click="save_favorit(v.id, i)" class="listThumb">
                <div class="thumbIcon">
                  <svg
                    v-if="v.is_favorite == 1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                    />
                  </svg>
                  <svg
                    v-if="v.is_favorite == 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="thumbFooter">
          <div class="footerStatus">
            {{ v.status_fn }}
          </div>
          <div class="footerTitle">
            {{ v.content }}
          </div>
          <!-- <div
            v-if="
              completeInfos && completeInfos.posts && completeInfos.posts.list && v.total_floor && v.total_floor > 0
            "
            class="footerContent floorUnit"
          >
            {{ v.total_floor }} طبقه
          </div> -->
          <div
            v-if="
              completeInfos && completeInfos.posts && completeInfos.posts.list
            "
            class="footerContent"
            v-html="formattedDetails(v.details)"
          ></div>
          <div class="footerDate">{{ v.created_fa || "-" }}</div>
        </div>
      </div>
      <div
        v-if="form.loadmore_loading && completeInfos?.posts?.list?.length > 0"
        class="loadeMoreLoader"
      >
        <span class="loaderSpinner"></span>
      </div>
    </div>
    <vue-bottom-sheet
      v-show="commentSheet"
      :open="commentSheet"
      ref="myBottomSheet"
      @close="closeBottomSheet"
    >
      <div class="ShowCommandBoxesMyBottomSheet">
        <el-scrollbar
          height="440px"
          class="commentListWrapper"
          @scroll="handleScrollComment"
        >
          <div
            v-for="(CommentUserLists, i) in CommentUserList"
            :key="i"
            class="AllChildCommentRefSheet"
          >
            <div class="ChildCommentRefSheetVg">
              <div class="ChildCommentRefSheet">
                <div class="ImageChildCommentRefSheet">
                  <img
                    :src="CommentUserLists.avatar"
                    :alt="CommentUserLists.name"
                  />
                </div>
                <div class="TitleChildCommentRefSheet">
                  <h1>
                    {{ CommentUserLists.name }}
                  </h1>
                  <p>
                    {{ CommentUserLists.description }}
                  </p>
                </div>
              </div>

              <VsxIcon
                iconName="MessageAdd1"
                :size="25"
                color="#0096c7"
                type="bold"
                @click="replay_focuse(CommentUserLists.id)"
              />
            </div>
            <div class="repliesList">
              <div
                v-for="(replaies, i) in CommentUserLists.replay"
                :key="i"
                class="ReplayChildCommentRefSheet"
              >
                <VsxIcon
                  style="margin-left: 10px"
                  iconName="Data2"
                  :size="20"
                  color="#999"
                  type="linear"
                />
                <div class="ImageChildCommentRefSheet">
                  <img :src="replaies.avatar" :alt="replaies.name" />
                </div>
                <div class="TitleChildCommentRefSheet">
                  <h1>
                    {{ replaies.name }}
                  </h1>
                  <p>
                    {{ replaies.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mobileNocomments"
            v-if="CommentUserList.length == 0 && !loadmore_loading"
          >
            نظری ثبت نشده است
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
        </el-scrollbar>

        <div class="dentMessageToCommentSpace"></div>

        <div v-if="!$store.getters.auth.loggedIn" class="dentMessageToComment">
          <span class="loginMessage"> برای ثبت نظر وارد حساب کاربری شوید </span>
        </div>
        <div v-else class="dentMessageToComment">
          <div class="sendCommentBtnWrapper">
            <div
              class="sendCommentBtn"
              v-if="!comment_btn_loading && !$store.state.auth.loggedIn"
              @click="showLoginBox"
            >
              <i class="fa-solid fa-paper-plane"></i>
            </div>
            <div
              class="sendCommentBtn"
              v-if="!comment_btn_loading && $store.state.auth.loggedIn"
              @click="save_comment(0, 'mob')"
            >
              <i class="fa-solid fa-paper-plane"></i>
            </div>

            <span v-if="comment_btn_loading" class="loader"></span>
          </div>

          <div class="mobileNewCommentInput">
            <input
              type="text"
              id="newComment_mob"
              v-model="newComment"
              :style="parent_id === 0 ? 'width: 100%;' : 'width: 82%'"
            />
          </div>
          <div v-if="parent_id !== 0" class="cancleReply" @click="replay_blur">
            انصراف
          </div>
        </div>
      </div>
    </vue-bottom-sheet>
    <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
  </div>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import { toast } from "vue3-toastify";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import { Skeletor } from "vue-skeletor";
import { Share } from "@capacitor/share";
import LoginUser from "./LoginUser.vue";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "builderPostDetails",
  components: {
    VueBottomSheet,
    Swiper,
    SwiperSlide,
    Skeletor,
    LoginUser,
  },
  data() {
    return {
      module: [Pagination],
      loading: false,
      newComment:'',
      completeInfos: [],
      commentSheet: false,
      comment_btn_loading: false,
      replyComment: -1,
      CommentUserList: [],
      showReply: -1,
      mobileShowReply: -1,
      comment_replay: [],
      comment_btn_replay_loading: [],
      parent_id: 0,
      page: 1,
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      total: 0,
      activeIndex: -1,
      loadingFollow: false,
      form: {
        page: 1,
        isLoading: false,
        loadmore_loading: false,
        LoadingSkeleton: false,
      },
      mode: "user",
      myprofile: false,
      ShowLoginBoxes: false,
      map: null,
      reloadKey: 0,
      maps: {},
      markers: {},
      markerOne: null,
      center: { latitude: 36.5663854, longitude: 52.6707147 },
      markerPosition: { longitude: 0, latitude: 0 },
      houseIcon: L.divIcon({
        html: `
          <div style="position: relative;">
            <div style="
              position: absolute;
              width: 70px;
              height: 70px;
              background: rgba(0, 0, 0, 0.2);
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "></div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
                <defs>
                    <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                    <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
                    <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
                    <g transform="translate(10.009 10.009)">
                        <mask id="wd87vlifuc" fill="#fff">
                            <use xlink:href="#m1l7efvoab"/>
                        </mask>
                        <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                        <g fill="#FFF" mask="url(#wd87vlifuc)">
                            <path d="M0 0H15.728V15.728H0z"/>
                        </g>
                    </g>
                </g>
            </svg>
          </div>`,
        className: "house-marker",
        iconSize: [70, 70],
        iconAnchor: [35, 35],
      }),
    };
  },
  methods: {
    async initializeMap(post) {
      try {
        const mapId = `map-${post.id}`;

        if (!this.maps[post.id]) {
          const map = L.map(mapId, {
            dragging: true,
            touchZoom: true,
            scrollWheelZoom: true,
            doubleClickZoom: true,
            boxZoom: true,
            keyboard: true,
            zoomControl: true,
          }).setView([post.lat, post.lng], 16);

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap Abarline",
          }).addTo(map);

          // اولین مارکر
          const marker = L.marker([post.lat, post.lng], {
            icon: this.houseIcon,
          }).addTo(map);

          this.maps[post.id] = map;
          this.markers[post.id] = marker;
          map.invalidateSize();
        } else {
          this.updateMapLocation(post);
        }
      } catch (error) {
        console.error("Map initialization error:", error);
      }
    },

    updateMapLocation(post) {
      const lat = post.lat;
      const lng = post.lng;
      if (!lat || !lng) return;

      const map = this.maps[post.id];
      if (!map) return;

      map.setView([lat, lng], 16);

      if (this.markers[post.id]) {
        map.removeLayer(this.markers[post.id]);
      }

      this.markers[post.id] = L.marker([lat, lng], {
        icon: this.houseIcon,
      }).addTo(map);

      map.invalidateSize();
    },

    /* getmounted(map) {
      this.map = map;
      this.initializeMap(map);
    }, */
    save_like(post, index) {
      var user_id = 0;
      if (!this.$store.state.auth.loggedIn) {
        toast("برای لایک کردن آگهی وارد حساب کاربری خود شوید.", {
          type: "error",
        });
        return;
      }
      if (
        post &&
        this.$store.state.auth.loggedIn
      ) {
        if (post.user_id == this.$store.state.auth.uid) {
          toast("امکان لایک کردن آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        this.helperGet(
          "save-like",
          "post_id=" + post.id + "&user_id=" + user_id
        ).then((r) => {
          this.completeInfos.posts.list[index].is_like = r.data.result;
          if (r.data.result == 1)
            this.completeInfos.posts.list[index].likes -= 1;

          if (r.data.result == 2)
            this.completeInfos.posts.list[index].likes += 1;
        });
      } else {
        this.ShowLoginBoxes = true;
      }
    },
    // save_favorit(post_id, index) {
    //   var user_id = 0;
    //   if (this.$store.state.auth.loggedIn) {
    //     user_id = this.$store.state.auth.uid;
    //     this.helperGet(
    //       "save-favorite",
    //       "post_id=" + post_id + "&user_id=" + user_id
    //     ).then((r) => {
    //       this.completeInfos.posts.list[index].is_favorite = r.data.result;
    //     });
    //   } else {
    //     this.ShowLoginBoxes = true;
    //   }
    // },
    handleScrollComment() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_postComment(); // متد لود داده‌هات
        }
      }

      // تغییر وضعیت یک div (مثلاً موقعیت فیلتر بالای صفحه)
      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },
    save_comment(parent_id = 0, from) {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت نظر وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      if (
        this.completeInfos &&
        this.completeInfos.posts &&
        this.completeInfos.posts.list &&
        this.completeInfos.posts.list.length > 0 &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.completeInfos.posts.list[this.activeIndex].user_id == this.$store.state.auth.uid) {
          this.newComment = "";
          toast("امکان ثبت نظر برای آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      let self = this;
      const formData = new FormData();

      formData.append(
        "related_id",
        this.completeInfos.posts.list[this.activeIndex].id
      );
      formData.append("related_to", "post");

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.parent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob" ? this.newComment : this.comment_replay[actualParentId]
        );
        self.comment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.newComment);
        self.comment_btn_loading = true;
      }

      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // Create new comment object
          // const newComment = {
          //   id: r.data.id || Date.now(),
          //   name: self.$store.state.auth.name || "کاربر",
          //   avatar: self.$store.state.auth.avatar || "",
          //   description:
          //     actualParentId !== 0
          //       ? from === "mob"
          //         ? this.newComment
          //         : this.comment_replay[actualParentId]
          //       : this.newComment,
          //   date: new Date().toLocaleDateString("fa-IR"),
          //   replay: [],
          // };

          if (actualParentId !== 0) {
            // Add reply to parent comment
            // const parentComment = self.CommentUserList.find(
            //   (comment) => comment.id === actualParentId
            // );
            // if (parentComment) {
            //   parentComment.replay.push(newComment);
            // }
            if (from === "mob") {
              self.newComment = "";
            } else {
              self.comment_replay[actualParentId] = "";
            }
          } else {
            // Add new comment to end of list
            // self.CommentUserList.push(newComment);
            self.newComment = "";
          }

          self.replyCommentCloseHandler();
          self.total += 1;

          toast('نظر شما با موفقیت ثبت شد و پس از تأیید مدیریت نمایش داده خواهد شد.', {
            type:'success'
          })
          self.parent_id = 0;

          self.completeInfos.posts.list[this.activeIndex].comments_count++;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.comment_btn_replay_loading[actualParentId] = false;
        self.comment_btn_loading = false;
      });
    },
    load_postComment(param) {
      let self = this;
      this.loadmore = true;
      this.loadmore_loading = true;
      this.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.CommentUserList = [];
        this.page = 1;
      }

      this.helperGet(
        "get-comment",
        "related_to=post" +
          "&related_id=" +
          this.completeInfos.posts.list[this.activeIndex].id +
          "&page=" +
          this.page
      ).then((res) => {
        if (res.data.result == 1) {
          this.total = res.data.data.total;
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          const newComments = [...res.data.data.list].reverse(); // معکوس کردن ترتیب کامنت‌ها
          self.CommentUserList = self.CommentUserList.concat(newComments);

          if (res.data.data.total_page == self.page) {
            this.loadmore = false;
          }
          self.comment_btn_replay_loading = [];
          self.CommentUserList.forEach(function (v) {
            self.comment_btn_replay_loading[v.id] = false;
          });
        }

        this.isLoading = false;
        this.loadmore_loading = false;
      });
    },
    OpenMessage(index) {
      this.$refs.myBottomSheet.open();
      this.commentSheet = true;
      this.activeIndex = index;
      this.load_postComment("first");
    },
    mobileReplyToggleHandler(index) {
      if (this.mobileShowReply === index) {
        this.mobileShowReply = -1;
      } else {
        this.mobileShowReply = index;
      }
    },
    replyCommentHandler(index) {
      this.replyComment = index;
    },
    replyCommentCloseHandler() {
      this.replyComment = -1;
    },
    replay_focuse(parent_id = 0) {
      this.parent_id = parent_id;
      document.getElementById("newComment_mob").focus();
    },
    replay_blur() {
      this.parent_id = 0;
      this.newComment = "";
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").blur();
      }
    },
    follow(target_id) {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        this.loadingFollow = true;
        if (target_id) {
          user_id = this.$store.state.auth.uid;
          this.helperPost("follow", {
            uid: user_id,
            target_id: target_id,
          }).then((r) => {
            this.completeInfos.is_follow = r.data.result;
            this.loadingFollow = false;
            this.user_info_func();
          });
        }
      } else {
        this.ShowLoginBoxes = true;
      }
    },
    editPostHandler(id) {
      if (id) {
        this.$router.push(`/builder-create-post/${id}`);
      }
    },
    del_post(id) {
      let self = this;
      this.$swal
        .fire({
          title: "پست حذف گردد؟",
          text: "پس از این عملیات پست برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    this.form.LoadingSkeleton = true;
                    setTimeout(() => {
                      self.user_info_func("first");
                    }, 500);
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    showLoginBox() {
      this.$refs.myBottomSheet.close();
      this.commentSheet = false;
      this.$nextTick(() => {
        this.ShowLoginBoxes = true;
      });
    },
    user_info_func(param) {
      let self = this;
      this.form.LoadingSkeleton = true;
      self.mode = "user";
      const uid = this.$route.params.userId;
      var user_id = 0;
      var list_type = "public";

      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        if (user_id == uid) {
          list_type = "own_profile";
          this.myprofile = true;
        }
      }

      this.form.loadmore = true;
      this.form.loadmore_loading = true;
      this.form.page += 1;
      if (param == "first") {
        this.form.isLoading = true;
        this.completeInfos = [];
        this.form.page = 1;
      }

      this.helperGet(
        "user-infos",
        "uid=" +
          uid +
          "&user_id=" +
          user_id +
          "&page=" +
          this.page +
          "&list_type=" +
          list_type +
          "&post_type=" +
          "portfolio"
      ).then((res) => {
        this.completeInfos = res.data;

        if (res.data.posts.total_page == self.form.page) {
          this.form.loadmore = false;
        }

        this.$nextTick(() => {
          this.completeInfos.posts.list.forEach((post) => {
            if (post.lat && post.lng) {
              this.$nextTick(() => {
                this.initializeMap(post);
              });
            }
          });
        });

        this.form.isLoading = false;
        this.form.loadmore_loading = false;
        this.form.LoadingSkeleton = false;
      });
    },
    handleWindowScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight + 100 >= fullHeight) {
        if (this.form.loadmore && !this.form.loadmore_loading) {
          this.user_info_func();
        }
      }
    },
    async shareContent(title) {
      const routeUId = this.$route.params.userId;
      const routeId = this.$route.params.id;
      if (this.$store.state.device == "Desktop") {
        const textToCopy = `shomalamlak.ir/builder-details/${routeUId}/${routeId}`;
        const shareUrl = document.createElement("textarea");
        shareUrl.value = textToCopy;
        document.body.appendChild(shareUrl);

        shareUrl.select();
        document.execCommand("copy");
        document.body.removeChild(shareUrl);

        toast("متن اشتراک گذاری کپی شد.", {
          type: "success",
          dangerouslyHTMLString: true,
        });
      } else {
        try {
          await Share.share({
            title: this.title,
            text: this.text,
            url:
              `shomalamlak.ir/builder-details/${routeUId}/${routeId}` +
              " - " +
              title,
            dialogTitle: "شمال املاک",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },
    showProfileHandler() {
      const uid = this.completeInfos.uid;
      this.$router.push({ path: "/profile-builder", query: { uid } });
    },
    formattedDetails(content) {
      return content ? content.replace(/(\r\n|\n|\r)/g, "<br>") : '';
    },
  },
  mounted() {
    const list = localStorage.getItem("completeInfos");
    window.addEventListener("scroll", this.handleWindowScroll);
    // const routeUID = this.$route.params.userId;
    const routeID = this.$route.params.id;
    console.log("routeID", routeID);
    if (list) {
      this.completeInfos = JSON.parse(list);
      console.log("this.completeInfos", this.completeInfos);
      setTimeout(() => {
        document
          .getElementById(routeID)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 0);
      this.completeInfos.posts.list.forEach((post) => {
        if (post.lat && post.lng) {
          this.$nextTick(() => {
            this.initializeMap(post);
          });
        }
      });
    } else {
      this.form.LoadingSkeleton = true;
      setTimeout(() => {
        this.user_info_func("first");
      }, 1000);
    }
  },
  beforeMount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
};
</script>

<style scoped lang="scss">
.builderDetails {
  width: 100%;
  padding: 0 0 16px;
  .detailsList {
    .listTumb {
      width: 100%;

      &:not(:first-child) {
        border-top: 1px solid #f1f1f1;
      }

      .thumbHeader {
        width: 100%;
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .headerContent {
          display: flex;
          align-items: center;
          gap: 12px;

          .contentPic {
            flex-shrink: 0;

            img {
              width: 42px;
              height: 42px;
              object-fit: cover;
              border-radius: 50%;
            }
          }

          .contentTitle {
            .userTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 0.85rem;
              margin-bottom: 2px;
            }

            .userRole {
              font-size: 0.75rem;
            }
          }
        }

        .headerOptions {
          display: flex;
          align-items: center;
          gap: 8px;
          .userFollowBtn {
            height: 28px;
            padding: 0 14px;
            border-radius: 9999px;
            background: #0096c7;
            color: #fff;
            font-size: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .userUnFollowBtn {
            height: 28px;
            padding: 0 14px;
            border-radius: 9999px;
            background: #fff;
            color: #0096c7;
            border: 1px solid #0096c7;
            font-size: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .userEditBtn {
            height: 28px;
            width: 28px;
            border-radius: 4px;
            background: #0096c7;
            color: #fff;
            font-size: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
          }
          .userDelBtn {
            height: 28px;
            width: 28px;
            border-radius: 4px;
            background: #f00;
            color: #fff;
            font-size: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
          }
        }
      }

      .thumbMain {
        .mainPic {
          width: 100%;
          aspect-ratio: 412/515;

          .swiper {
            height: 100% !important;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .mainOptions {
          padding: 4px 16px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          .optionsList {
            display: flex;
            align-items: flex-start;

            &:first-child {
              .listThumb {
                &:first-child {
                  padding-right: 0;
                }
              }
            }

            &:last-child {
              .listThumb {
                padding-left: 0;
              }
            }

            .listThumb {
              text-align: center;
              padding: 8px;

              .thumbIcon {
                width: 24px;
                height: 24px;
                margin-bottom: 8px;
                margin-left: auto;
                margin-right: auto;
                cursor: pointer;

                &.liked {
                  color: #f00;
                }

                svg {
                  width: 24px;
                  height: 24px;
                }
              }

              .thumbNum {
                text-align: center;
                font-size: 0.9rem;
              }
            }
          }
        }
      }

      .thumbFooter {
        padding: 0 16px 20px;

        .footerStatus {
          width: fit-content;
          padding: 4px 8px;
          border-radius: 24px;
          background: #f7f7f7;
          font-size: 0.85rem;
          color: #0096c7;
          flex-shrink: 0;
        }

        .footerTitle {
          font-family: "iranyekanB", sans-serif;
          font-size: 1rem;
        }

        .footerContent {
          margin-bottom: 8px;
          width: 100%;
          font-size: 0.85rem;
          text-align: justify;
          line-height: 24px;

          &.floorUnit {
            margin-bottom: 0;
            margin-top: 6px;
          }
        }

        .footerDate {
          color: rgb(107, 114, 128);
          font-size: 0.75rem;
        }
      }
    }
  }
}

.accommodation-pdp-specification-icon i {
  font-size: 24px;
}

.accommodation-pdp-specification-icon {
  margin-top: 0 !important;
}

.ClassPositionsLayers {
  width: 100%;
  height: 468px;
  border-radius: 8px;
}

.desktopComments {
  .j-list-section-title__content {
    display: block !important;
    width: 100%;
  }
  .j-list-section-title__title {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.commentTitle {
  font-family: "iranyekanB", sans-serif;
  font-weight: 500;
  font-size: 24px;

  span {
    font-size: 18px;
  }
}

.showCommentsModalDesktop {
  padding: 0 12px;
  border: 2px solid #0096c7;
  height: 38px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.commentsList {
  width: 96%;
  margin: 0 auto;
  padding: 24px 0;

  .commentInputWrapper {
    display: flex;
    margin-bottom: 24px;

    .inputUserProfile {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #000;
      margin-left: 16px;
    }

    &.newCommentInput {
      padding-bottom: 24px;
      border-bottom: 1px solid #eee;

      .commentInput {
        .addCommentInput {
          input {
            border: 1px solid #ddd;
            padding: 12px 8px;
            border-radius: 6px;
            font-size: 1rem;

            &:focus {
              border: 1px solid #0096c7;
            }
          }

          &::after {
            display: none;
          }
        }
      }
    }

    .commentInput {
      flex: 1;

      .addCommentInput {
        position: relative;
        margin-bottom: 8px;
        input {
          display: block;
          width: 100%;
          padding: 2px 0;
          border-bottom: 1px solid #ccc;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          display: block;
          width: 100%;
          height: 1.5px;
          background: #0096c7;
          transform: scaleX(0);
          transition: all 0.2s;
        }

        &.focus {
          &::after {
            transform: scaleX(1);
          }
        }
      }

      .commentInputBtns {
        width: 100%;
        display: flex;
        justify-content: left;

        .commentBtn,
        .cancleBtn {
          display: flex;
          align-items: center;
          height: 36px;
          padding: 0 16px;
          font-size: 14px;
          line-height: 36px;
          border-radius: 18px;
          background: #0096c7;
          color: #fff;
          margin-right: 6px;
          cursor: pointer;
        }

        .cancleBtn {
          background: #e5f0ff;
          color: #0096c7;
        }

        .commentBtn.disabled {
          pointer-events: none;
          cursor: none;
          opacity: 0.4;
        }
      }
    }
  }

  .commentThumb {
    display: flex;
    margin-bottom: 16px;

    .commentProfile {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0096c7;
      flex-shrink: 0;
      margin-left: 16px;
    }

    .commentContent {
      flex: 1;

      .commentHeader {
        display: flex;
        align-items: center;
        gap: 8px;
        .userName {
          font-family: "iranyekanB", sans-serif;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .commentDate {
          font-family: "iranyekan", sans-serif;
          font-size: 12px;
          color: #999;
        }
      }

      .commentText {
        font-family: "iranyekan", sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.25rem;
        margin-bottom: 2px;
      }

      .commentBtns {
        display: flex;
        margin-bottom: 4px;

        .commentLikesBtn {
          display: flex;

          .likeBtnWrapper {
            display: flex;

            .likeNum {
              margin-left: 8px;
              margin-right: 2px;
              padding-top: 4px;
              font-size: 14px;
            }
          }

          .likeBtn,
          .disLikeBtn {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg.commentBtnIcon {
              font-size: 14px;
              stroke: #0096c7 !important;
              path {
                stroke: #0096c7 !important;
              }
            }

            &:hover {
              background: #e5f0ff;
            }
          }
        }

        .commentReplyBtn {
          margin-right: 8px;
          margin-top: 6px;
          padding: 0 8px;
          font-size: 13px;
          line-height: 24px;
          border-radius: 16px;
          cursor: pointer;
          background: #e5f0ff;
          color: #0096c7;

          &:hover {
            background: #e5f0ff;
            color: #0096c7;
          }
        }
      }

      .commentInputWrapper {
        display: none;

        &.show {
          display: flex;
          margin-top: 6px;
        }
        padding-right: 4px;
        margin-bottom: 2px;
        .inputUserProfile {
          width: 24px;
          height: 24px;
        }
      }

      .commentsReplyToggler {
        .commentsReplyToggleBtn {
          padding: 0 16px;
          width: fit-content;
          height: 36px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          border-radius: 16px;
          color: #0096c7;
          cursor: pointer;

          &:hover {
            background: #e5f0ff;
          }
        }
      }

      .commentsReply {
        display: none;

        &.show {
          display: block;
        }
        .commentThumb {
          width: 100%;
          .commentProfile {
            width: 24px;
            height: 24px;
            margin-right: 16px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

.pdp-host-info {
  .postDetailsContainer {
    width: 100%;
    .detailsColumn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:first-of-type {
        display: none;
      }

      .pdp-host-info-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
    }
  }
}

.product-amenities-list {
  display: flex;
  align-items: flex-start;
  // gap: 8px;
  flex-wrap: wrap;

  .product-amenities-list__item {
    display: flex;
    align-items: center;
    width: auto !important;
    padding: 4px 0;
    color: #000;
    border-radius: 6px;
    margin: 0 !important;
    font-size: 14px;

    &:not(:last-of-type) {
      &::after {
        content: "-";
        margin: 0 8px;
        display: block;
      }
    }
  }
}

.commentsDestopBody {
  width: 100%;
}

.loginMessage {
  font-size: 0.9rem;
}

.addCommentForm {
  position: relative;
  margin-bottom: 16px;

  .commentSubmit {
    position: absolute;
    left: 32px;
    top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 14px;
    z-index: 2;
    background: #e6e6e6;
    color: #000;
    pointer-events: none;
    cursor: not-allowed;
    &.active {
      background: #0096c7;
      color: #fff;
      pointer-events: auto;
      cursor: pointer;
    }
  }

  .form__group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
    width: 94%;
    margin: 0 auto;
  }

  .form__field {
    position: relative;
    z-index: 1;
    font-family: "iranyekan", sans-serif;
    width: 100%;
    border: 0;
    border-bottom: 2px solid #9b9b9b;
    outline: 0;
    font-size: 1rem;
    color: #000;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;

    &::placeholder {
      color: transparent;
    }
    &:focus {
      outline: none !important;
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
    }

    &:placeholder-shown ~ .form__label {
      font-size: 1rem;
      cursor: text;
      top: 20px;
    }
  }

  .form__label {
    position: absolute;
    top: 24px;
    display: block;
    transition: 0.2s;
    font-size: 14px;
    color: #9b9b9b;
  }

  .form__field:focus {
    ~ .form__label {
      position: absolute;
      top: 0;
      display: block;
      transition: 0.2s;
      font-size: 1rem;
      color: #0096c7;
    }
    padding-bottom: 6px;
    border: 3px solid #0096c7;
  }
  .form__field {
    &:required,
    &:invalid {
      box-shadow: none;
    }
  }
}

.ShowCommandBoxesMyBottomSheet {
  height: 500px;
  overflow-y: hidden;

  .dentMessageToCommentSpace {
    height: 60px;
  }

  .dentMessageToComment {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 60px;
    background: #ffffff;
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ededed;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 5px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .dentMessageToComment {
    height: 60px;
    display: flex;
    gap: 12px;
    align-items: center;

    .sendCommentBtnWrapper {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0096c7;
      border-radius: 12px;
      flex-shrink: 0;

      .sendCommentBtn {
        color: #fff !important;
      }

      span.loader {
        margin: 0 !important;
      }
    }

    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 12px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .AllChildCommentRefSheet {
    margin: auto;
    width: 95%;
    padding: 10px;
    position: relative;
  }

  .ChildCommentRefSheetVg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      cursor: pointer;
    }
  }

  .ChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 15px;
    height: 50px;
  }

  .ReplayChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    margin-top: 20px;
    .TitleChildCommentRefSheet {
      border-radius: 10px;
      h1 {
        font-size: 0.85rem;
      }

      p {
        font-size: 0.8rem;
        color: #333;
      }
    }

    .ImageChildCommentRefSheet {
      height: 30px;
      width: 30px;
      border-radius: 100%;
      overflow: hidden;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .ImageChildCommentRefSheet {
    height: 34px;
    width: 34px;
    border-radius: 100%;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .TitleChildCommentRefSheet {
    h1 {
      font-size: 0.9rem;
      font-weight: 500;
      color: rgb(21, 21, 77);
      font-family: "iranyekanB";
    }

    p {
      font-size: 0.75rem;
      color: #555;
      font-family: "iranyekan";
    }
  }
}

.mobileTitle {
  display: none;
}

.postDetailsContainer {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;

  .pdp-host-info-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pdp-host-info-content__title {
      // font-size: 1.15rem;
      // margin-bottom: 0;
      // text-align: left;
    }
  }
}

.titleWrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  .uploadedDate {
    margin: 0 !important;
  }
}

.uploadedDate {
  width: fit-content;
  position: relative;
  margin-top: 16px;
  font-size: 0.8rem;
  padding-right: 12px;
  background: rgb(229 240 255);
  color: #0096c7;
  padding: 6px 10px;
  border-radius: 24px;
}

.contactOptionBoxesSection {
  display: none;
}

.comment-card__content {
  padding: 1rem;

  .comment-card__text {
    font-size: 0.8rem !important;
  }
}

.ShowClickFollow {
  line-height: 26.5px;
  padding: 0 20px;
  width: 138px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-align: center;
  border-radius: 5px;
  background: #0096c7;
  border: 1px solid #0096c7;
  transition: 0.1s ease-in-out;
  cursor: pointer;
  color: #fff;

  &.unfollow {
    background: #f00;
    color: #fff;
    border: 1px solid #f00;
  }
}

.mapboxContainer {
  .map {
    height: 336px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #0096c7;
  }

  .postLocation {
    font-size: 14px;
    margin-top: -24px;
    margin-bottom: 28px;

    span {
      font-family: "iranyekanL", sans-serif;
    }
  }
}

.house-marker {
  background: none;
  border: none;
}

.DetailWithShow {
  padding-top: 54px;
  padding-bottom: 82px;
}

.ol-viewport.ol-touch div {
  &:nth-of-type(4) {
    z-index: 9 !important;
  }
}

.mobildeShowReplyBtn {
  position: relative;
  font-size: 12px;
  margin-right: 40px;
  margin-top: 10px;
  margin-bottom: 6px;
  color: #0096c7;
  padding-right: 12px;
  cursor: pointer;

  &::before {
    content: "";
    display: block;
    width: 6px;
    height: 1px;
    background: #0096c7;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.repliesList {
  margin-top: -10px;
}

.mobileNocomments {
  padding: 48px 0;
  font-size: 1rem;
  color: #777;
  text-align: center;
}

.pdp-host-info-content__titleWrapper {
  display: flex;
  flex-direction: column;

  h2 {
    margin: 0 !important;
  }

  .followersNum {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgb(111, 114, 133);
  }
}

.contactBoxInfo {
  display: none;
}
.accommodation-description-content {
  & > div {
    line-height: 24px;
  }
}

@media (max-width: 1000px) {
  .contactBoxInfo {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 72px;
    padding: 12px 16px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    z-index: 999;

    .contactBoxInfoWrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .contactInfoBtn {
        width: calc(50% - 8px);
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #0096c7;
        border-radius: 6px;
        font-size: 1.05rem;

        &:not(.btnLight) {
          background: #0096c7;
          color: #fff;
        }

        &.btnLight {
          background: #fff;
          color: #0096c7;
        }
      }
    }
  }
  .DetailWithShow {
    padding-top: 0;
  }
  .desktopComments {
    display: none !important;
  }
  .accommodation-pdp-content__main > * {
    padding: 16px 0 24px;
  }

  .accommodation-pdp-content__main > :not(:last-child) {
    border-bottom: 1px solid #eee;
  }

  .accommodation-pdp-specifications-heading {
    margin-bottom: 16px;
  }

  .mapboxContainer {
    .map {
      height: 246px;
    }

    .postLocation {
      margin-top: -10px;
      margin-bottom: 24px;
    }
  }

  .ShowClickFollow {
    line-height: 26.5px;
    padding: 0 20px;
    width: auto;
    height: 30px;
    text-align: center;
    border-radius: 5px;
    background: #0096c7;
    border: 1px solid #0096c7;
    transition: 0.1s ease-in-out;
    cursor: pointer;
    color: #fff;
    font-size: 12px;

    &.unfollow {
      background: #f00;
      color: #fff;
      border: 1px solid #f00;
    }
  }

  .accommodation-pdp-head {
    display: none !important;
  }

  .accommodation-pdp-content {
    display: block !important;
  }

  .comment-card-info {
    padding: 0.25rem;
  }

  .accommodation-pdp-specifications__container > :not(:last-child) {
    margin-bottom: 1.35rem !important;
  }

  .accommodation-pdp-specification-content__title {
    font-size: 0.9rem !important;
    margin: 0 !important;
    font-family: "iranyekan", sans-serif;
  }

  .accommodation-pdp-specification-description__item {
    font-family: "iranyekanL", sans-serif;
    font-size: 0.75rem;
  }

  .comment-card-guest-info__avatar {
    width: 2.5rem;
    height: 2.5rem;
  }

  .comment-card-guest-info__title {
    font-size: 1rem !important;
  }

  .comment-card-guest-info__desc {
    font-size: 0.75rem !important;
    font-family: "iranyekanL", sans-serif;
    margin-top: -4px;
  }

  .accommodation-pdp-specifications-heading__title,
  .product-amenities-heading__title,
  .accommodation-description-heading__title {
    font-size: 1.15rem !important;
  }

  .accommodation-description-content {
    font-size: 12px;
    display: block !important;

    & > div {
      font-size: 13px;
      line-height: 24px;
    }
  }

  .product-amenities-heading,
  .accommodation-description-heading {
    margin-bottom: 16px !important;
  }

  .contactOptionBoxesSection {
    display: block;
    padding: 16px 0 94px;
  }

  .postTitleContainer {
    width: 100%;

    .postTitle {
      width: 100%;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.25rem;
    }

    .postPrice {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .postPriceWrapper {
        font-family: "iranyekanL", sans-serif;
        font-size: 0.9rem;
      }

      .uploadedDate {
        margin: 0 !important;
      }
    }
  }

  .contactOptionBoxes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .optionBox {
      width: 48%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      background: #0096c7;
      border-radius: 6px;
      color: #fff;
      font-size: 16px;
    }
  }

  .pdp-host-info {
    &.mobileTitle {
      display: block;
    }
    .postDetailsContainer {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;

      .pdp-host-info-avatar {
        width: 3rem;
        height: 3rem;
      }

      .pdp-host-info-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .pdp-host-info-content__title {
          font-size: 1rem;
          margin-bottom: 0;
          text-align: left;
        }
      }
    }
  }
  .accommodation-pdp-sidebar-calendar {
    p {
      font-size: 1rem !important;
    }
  }
}

.sendCommentBtn {
  width: 32px;
  height: 32px;
  background: transparent;
  font-size: 20px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.accommodation-landmark {
  justify-content: right !important;
  gap: 4px !important;
  align-items: center;
}

.loader {
  height: 20px;
  width: 20px;
  margin-top: 0 !important;
}

/* Add any needed bottom sheet styles */
.vue-bottom-sheet {
  z-index: 1000;
}

.product-amenities
  .mapboxContainer
  .map.leaflet-container
  .leaflet-control-container
  .leaflet-bottom.leaflet-right {
  z-index: 900 !important;

  :deep(.leaflet-bottom) {
    z-index: 900 !important;
  }
}

.reportBtn {
  height: 38px;
  width: 132px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0096c7;
  border-radius: 8px;
  color: #fff;
  font-size: 0.8rem;
  margin-top: 24px;
  margin-bottom: -12px;
  margin-left: auto;
  margin-right: auto;
  font-family: "iranyekanB", sans-serif;
}

.pdp-host-info
  .postDetailsContainer
  .pdp-host-info-content
  .pdp-host-info-content__title {
  text-align: right !important;
}

@media (min-width: 1000px) {
  .reportFixedBtn {
    display: none;
  }
}

@media (max-width: 1000px) {
  .reportFixedBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 16px;
    width: fit-content;
    background: #0096c7;
    color: #fff;
    font-family: "iranyekanB", sans-serif;
    font-size: 0.7rem;
    border-radius: 8px;
    margin: -8px auto -8px;
  }
}

.desktopPhoneNumber {
  font-size: 0.9rem;
}

.dark {
  .accommodation-pdp-head .title h1,
  .specifications .city-province {
    color: #fff;
  }

  .titleWrapper {
    .uploadedDate {
      background: rgb(63, 70, 79);
    }
  }

  .postTitleContainer .postPrice .uploadedDate {
    background: rgb(63, 70, 79);
  }
}

.commentloader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #0096c7;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loadeMoreLoader {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;

  .loaderSpinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid #0096c7;
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
}

.dark {
  .builderDetails {
    color: #fff;
    .detailsList {
      .listTumb {
        &:not(:first-child) {
          border-top: 1px solid #302f2f;
        }
        .thumbHeader {
          .headerContent {
            .contentTitle {
              color: #fff;
            }
          }

          .headerOptions {
            .userUnFollowBtn {
              background: #101a23;
            }
          }
        }
        .thumbFooter {
          .footerStatus {
            background: #25292e !important;
          }
        }
      }
    }
  }
}

.map {
  width: 100%;
  height: 100%;
}
</style>
